import classNames from 'classnames';
import { playAudio, parsingAI } from '@/utils/audioPlay';
import { IPictureCompletionProp, IlistItem } from '@/utils/ctype';
import { CorrectSvg, ErrorSvg } from '@/pages/Mock/Svg';
// import Input from '../../../components/MyInput';
import Analysis from '../../../components/Analysis';
import SpeechBtn from '../../../components/SpeechBtn';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';

export default function PictureMatchingQuestion(props: IPictureCompletionProp) {
  const {data, groupId, type, answerMap, saveAnswerHandle, currentFocus, isAI, isListen, keyIndex, answerAllText, setFocusIndexHandle, feedbackMap} = props;
  const { img_url, list, option, title } =data;

  const handleInputNext = (num: number, id: number, value: string) => {
    if (isAI) {
      return;
    }
    saveAnswerHandle(num, {
      group_id: groupId,
      id: Number(id),
      type,
      answer: [value]
    });
  };

  const createAIType = (answer: string, listItem: IlistItem) => {
    if (!isAI) {
      return;
    }
    if (feedbackMap && listItem.id) {
      return feedbackMap[listItem.id];
    }
  };

  return <div className={style.layout}>
    <div className={style.left}>
      { title ? <div data-exam-text-size="20" className={style.title}>{title}</div> : null }
      <img src={img_url} alt="" className={style.picture}/>
    </div>
    <div data-exam-surface className={style.answerBox}>
      <table className={style.table}>
        <thead>
          <th className={style.th}></th>
          {option?.map((item: {title: string;id: number; titleHtml: string;}, index: number) =>{
            return (
              <th key={item.id} className={style.th}>
                <div style={{textAlign: 'center'}} data-key={`$question.question.${keyIndex}.option.${index}.title`} >
                  <HtmlParser htmlString={item.titleHtml || item.title}></HtmlParser>
                </div>
              </th>
            );
          })}
        </thead>
        <tbody>
          {list.map((item, itemIndex: number) => {
            const answerData = answerMap[`${groupId}_${type}_${item.id}`];
            const answer = answerData && answerData[0];
            const value = answerData ? answerData[0] : '';
            const questionCorrected = createAIType(value, item) === 'success';
            return (
              <tr key={item.number} className={style.row}>
                <td className={style.question}>
                  <div className={style.questionText} id={`question${item.number}`}>
                    <span data-exam-neutral-text className={classNames(style.questionNumber, currentFocus === item.number ? style.active : '')} data-key={`$question.question.${keyIndex}.list.${itemIndex}.number`}><HtmlParser htmlString={item.numberHtml || item.number}></HtmlParser></span>
                    <span className={style.questionTitle} data-key={`question.question.${keyIndex}.list.${itemIndex}.title`}><HtmlParser htmlString={item.title}></HtmlParser></span>
                    {isAI && !answer ? <span className={classNames(style.fail, style.answerText)} data-key={`answerAllText.${item.number-1}`}><HtmlParser htmlString={answerAllText[item.number - 1]}></HtmlParser></span> : null }
                    {isAI && <span className={style.icon}>{questionCorrected ? CorrectSvg({className: style.svgIcon}) : ErrorSvg({className: style.svgIcon})}</span>}
                    {isAI && isListen ? <SpeechBtn onClick={() => {playAudio(item);}} index={item.number}></SpeechBtn> : null}
                    {isAI ? <Analysis onClick={() => {parsingAI(item);}}></Analysis> : null}
                  </div>
                </td>
                {
                  option?.map((oItem: {title: string;id: number; titleHtml: string;}) => {
                    const isAnswer = oItem.title === answer;
                    const isCorrect = (isAI && questionCorrected && isAnswer) || (isAI && !questionCorrected && item.display_answerHtml.includes(oItem.title));
                    const isWrong = isAI && !questionCorrected && isAnswer;
                    return <td className={style.option} onClick={() => handleInputNext(item.number, item.id, oItem.title)} key={oItem.id}>
                      <i
                        className={style.optionCheck}
                        data-status={
                          isCorrect ? 'right' : isWrong ? 'wrong' : isAnswer ? 'progress' : ''
                        }
                      ></i>
                    </td>;
                  })
                }
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>;
}


